"use client";

import { MotionUIThemeProvider } from "@/components/motion-ui/ui-theme";
import motionTheme from "@/motion.theme";
import type { ReactNode } from "react";

export function MotionProvider({ children }: { children: ReactNode }) {
  return (
    <MotionUIThemeProvider theme={motionTheme}>
      {children}
    </MotionUIThemeProvider>
  );
}
